import React, { useEffect, useMemo, useState } from "react";
import { Root } from "../../../components/business/CdBalance/style";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Ptag } from "../../../components/fonts";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  HeaderRow,
  MaterialTable,
} from "../../../components/GmcDashbaord/styles";
import { formatDateReverse, formatToRupees } from "../../../utils/utils";

const HEADERS = [
  "Claim No.",
  "Employee No.",
  "Employee Name",
  "Patient Name",
  "Date of Admission",
  "Buffer Amount Utilized",
];

function BufferTable() {
  const { state } = useLocation();
  const [tableRows, setTableRows] = useState();
  useEffect(() => {
    const tableData = state.details && state.details.history_data;
    setTableRows(tableData);
  }, [state]);
  console.log(state.details);
  const renderTable = useMemo(() => {
    return (
      <TableContainer
        sx={{
          borderRadius: "14px !important",
          scrollbarWidth: "thin",
        }}
      >
        <Table sx={MaterialTable}>
          <TableHead>
            <TableRow>
              {HEADERS.map((header, index) => (
                <TableCell
                  key={index}
                  variant="head"
                  align="center"
                  sx={HeaderRow}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows &&
              tableRows.map((batch, index) => {
                return (
                  <TableRow
                    key={batch.id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell align="center" component="th" scope="row">
                      <Ptag style={{ display: "inline" }}>
                        {batch.claim_number || "-"}
                      </Ptag>
                    </TableCell>
                    <TableCell align="center" component="th" scope="row">
                      <Ptag style={{ display: "inline" }}>
                        {batch.employee_number || "-"}
                      </Ptag>
                    </TableCell>
                    <TableCell align="center" component="th" scope="row">
                      <Ptag style={{ display: "inline" }}>
                        {batch.employee_name || "-"}
                      </Ptag>
                    </TableCell>
                    <TableCell align="center" component="th" scope="row">
                      <Ptag style={{ display: "inline" }}>
                        {batch.patient_name || "-"}
                      </Ptag>
                    </TableCell>
                    <TableCell align="center" component="th" scope="row">
                      <Ptag style={{ display: "inline" }}>
                        {(batch.date_of_admission &&
                          formatDateReverse(batch.date_of_admission)) ||
                          "-"}
                      </Ptag>
                    </TableCell>
                    <TableCell align="center" component="th" scope="row">
                      <Ptag style={{ display: "inline" }}>
                        {(batch.buffer_amount_utilised &&
                          formatToRupees(batch.buffer_amount_utilised)) ||
                          "-"}
                      </Ptag>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [tableRows]);
  return (
    <>
      <Root style={{ padding: "4rem" }}>
        <Ptag fontSize="20px" fontWeight="700" marginBottom="2rem">
          History
        </Ptag>
        {tableRows && renderTable}
      </Root>
    </>
  );
}

export default BufferTable;
